
import axiosInstance from "../../../api/AxiosInstance";
import { endpoints } from "../../../services/endpoints";
import { deleteEventRequest, deleteEventRequestError, deleteEventRequestSuccess } from "../../slices/event-management/DeleteEventSlice";

export const DeleteEventAPI =
    (data) => async (dispatch) => {
        console.log(data, "data")
        try {
            dispatch(deleteEventRequest());
            // Returning the promise so we can await it in handleSubmit
            const response = await axiosInstance({
                method: "POST",
                url: endpoints.deleteEvent,
                data: data,
            })
            return dispatch(deleteEventRequestSuccess(response.data));
        } catch (error) {
            const _error = {
                data: error?.response?.data?.message || error?.message,
                status: error?.response?.status || error?.status,
            };
            return dispatch(deleteEventRequestError(_error));
        }
    };
